import React, { useEffect, useState } from "react";

import { Checkbox, TableCell, TableRow, TextField } from "@material-ui/core";
import { TextValidator } from "react-material-ui-form-validator";

import { withStyles } from "@material-ui/core/styles";

const StyledTableRow = withStyles((theme) => ({
  root: {
    height: 30,
  },
}))(TableRow);

const StyledTableCell = withStyles((theme) => ({
  root: {
    padding: "0px 16px",
  },
}))(TableCell);

export const PracticaLabItem = ({index, practica, seleccion = false}) => {
  const [checkbox, setCheckbox] = useState(false);
  const [cantidad, setCantidad] = useState(seleccion 
    ? 1
    : practica?.cantidad
  );
  const color = seleccion ? '' : practica.autorizada ? 'springgreen' : 'tomato';
  
  const onChangeCheckboxHandler = (e) => {
    const checked = e.target.checked;

    if (checked) {
      setCantidad(1);
    } else {
      setCantidad("");
    }
    setCheckbox(checked);
  };

  useEffect(() => {
    setCheckbox(practica.agrupada);
    // eslint-disable-next-line
  }, []);

  return (
    <StyledTableRow
      practica={`practica-${index}`}
      style={{
        display: "table",
        width: "98.5%",
        tableLayout: "fixed",
        height: "20px",
        backgroundColor: color
      }}
    >
      {seleccion &&
        <StyledTableCell style={{ width: "10%", height: "auto !important" }}>
          <Checkbox
            name={`practica-${index}`}
            onChange={onChangeCheckboxHandler}
            checked={checkbox}
          />
        </StyledTableCell>
      }
      <StyledTableCell style={{ width: "50%", height: "auto !important" }}>
        {`${practica.codNom} - ${practica.desNom}`}
      </StyledTableCell>
      {seleccion
        ? 
          <StyledTableCell style={{ width: "10%", height: "auto !important" }}>
            <TextValidator
              autoComplete="off"
              margin="normal"
              inputProps={{ style: { textAlign: "center" } }}
              type="number"
              name={`cantidad-${index}`}
              disabled={!checkbox || true}
              value={checkbox ? cantidad : ''}
              onChange={(e) => setCantidad(e.target.value)}
              validators={["minNumber: 1"]}
              errorMessages={["El número debe ser mayor a 0"]}
            />
          </StyledTableCell>
        :
          <>
            <StyledTableCell style={{ width: "10%", height: "auto !important" }}>
              <TextField
                autoComplete="off"
                margin="normal"
                inputProps={{ style: { textAlign: "center" } }}
                type="number"
                name={`cantidad-${index}`}
                disabled={true}
                value={cantidad}              
              />
            </StyledTableCell>
            <StyledTableCell style={{ width: "15%", height: "auto !important" }}>
              {practica.autorizada ? 'AUTORIZADA' : 'AUDITORIA'}
            </StyledTableCell>
            <StyledTableCell style={{ width: "10%", height: "auto !important" }}>
              {practica.exento ? 'SI' : 'NO'}
            </StyledTableCell>
            <StyledTableCell style={{ width: "15%", height: "auto !important" }}>
              {practica.importeCoseguro > 0 ? `$ ${parseFloat(practica.importeCoseguro).toFixed(2)}` : '$ 0'}
            </StyledTableCell>
          </>            
      }        
    </StyledTableRow>
  );
};
